import cx from "classnames";
import { getConsole } from "lib/getConsole";
import { urls } from "lib/urls";
import React, { Fragment } from "react";
import { GalleryHack } from "./GalleryHack";
import styles from "./Image.scss";
const console = getConsole("common", "Image");
// non-responsive (fixed size) image component.
// handles:
// - formatting retina srcSet
// - launching a gallery on click
export class Image extends React.PureComponent {
  // TODO - eventually, gallery state should live only in the URL
  state = {
    galleryActive: false,
  };

  onClick = (e) => {
    const { gallery, onClick } = this.props;
    if (gallery && onClick) {
      console.warn(
        `You have provided both a "gallery" and "onClick" prop to <Image />. This is unsupported and the onClick prop will be ignored!`
      );
    }
    if (gallery) {
      // currently, we only support 'user' galleries in this component. This
      // will be fixed when https://github.com/ridewithgps/ridewithgps/pull/7322
      // ships
      gallery.parentType === "user" && this.setState({ galleryActive: true });
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  hasClickBehavior = () => {
    const { gallery, onClick } = this.props;
    return gallery || onClick;
  };

  onGalleryRequestClose = () => {
    this.setState({ galleryActive: false });
  };

  render() {
    const { id, resizingType, width, height, gravity, enlarge, gallery, className, onClick, ...props } = this.props;

    const { galleryActive } = this.state;

    // normal devices
    const _1x = urls.photos.custom(id, {
      resizingType,
      width,
      height,
      gravity,
      enlarge,
    });
    // retina devices (older retina iPhones, most Android devices)
    const _2x = urls.photos.custom(id, {
      resizingType,
      width: width * 2,
      height: height * 2,
      gravity,
      enlarge,
    });
    // super retina devices (iPhone X/XS, iPhone Plus models)
    const _3x = urls.photos.custom(id, {
      resizingType,
      width: width * 3,
      height: height * 3,
      gravity,
      enlarge,
    });
    // all together
    const srcSet = `${_1x} 1x, ${_2x} 2x, ${_3x} 3x`;
    const cn = cx(className, (gallery || onClick) && styles.clickable);
    const img = (
      <img {...props} height={height} width={width} src={_1x} srcSet={srcSet} onClick={this.onClick} className={cn} />
    );

    if (!galleryActive) {
      return img;
    }

    return (
      <Fragment>
        {img}
        <GalleryHack gallery={gallery} defaultActive={id} onRequestClose={this.onGalleryRequestClose} />
      </Fragment>
    );
  }
}
